// extracted by mini-css-extract-plugin
export var body = "_31-1";
export var bodyPadded = "_31-2";
export var chevron = "_31-4";
export var chevronOpen = "_31-5";
export var header = "_31-0";
export var icon = "_31-3";